import { render, staticRenderFns } from "./ProcessChargesTable.vue?vue&type=template&id=5a070370&scoped=true&"
import script from "./ProcessChargesTable.vue?vue&type=script&lang=js&"
export * from "./ProcessChargesTable.vue?vue&type=script&lang=js&"
import style0 from "./ProcessChargesTable.vue?vue&type=style&index=0&id=5a070370&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a070370",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a070370')) {
      api.createRecord('5a070370', component.options)
    } else {
      api.reload('5a070370', component.options)
    }
    module.hot.accept("./ProcessChargesTable.vue?vue&type=template&id=5a070370&scoped=true&", function () {
      api.rerender('5a070370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ProcessCharges/components/ProcessChargesTable.vue"
export default component.exports